import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {LinkSchema} from './link'

export const PricingFeatureVariantSchema = z.enum(['Included', 'Excluded', 'Title', 'Spark'])
export type PricingFeatureVariant = z.infer<typeof PricingFeatureVariantSchema>

export const PricingFeatureSchema = buildEntrySchemaFor('pricingFeature', {
  fields: z.lazy(() =>
    z.object({
      title: safeOptional(z.string()),
      text: RichTextSchema,
      variant: safeOptional(PricingFeatureVariantSchema),
    }),
  ),
})
export type PricingFeature = z.infer<typeof PricingFeatureSchema>

export const PricingPlanSchema = buildEntrySchemaFor('pricingPlan', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
      price: z.number(),
      originalPrice: safeOptional(z.string()),
      priceTrailing: safeOptional(z.string()),
      actionMessage: safeOptional(RichTextSchema),
      featureListTitle: safeOptional(z.string()),
      highlight: safeOptional(z.string()),
      featureList: safeOptional(z.array(PricingFeatureSchema)),
      trailingText: safeOptional(RichTextSchema),
      primaryCta: safeOptional(LinkSchema),
      secondaryCta: safeOptional(LinkSchema),
    }),
  ),
})

export type PricingPlan = z.infer<typeof PricingPlanSchema>
